import { render, staticRenderFns } from "./ProductTabsNavigation.vue?vue&type=template&id=1eeabd8e&scoped=true&"
import script from "./ProductTabsNavigation.vue?vue&type=script&lang=ts&"
export * from "./ProductTabsNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./ProductTabsNavigation.vue?vue&type=style&index=0&id=1eeabd8e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eeabd8e",
  null
  
)

export default component.exports